import React from "react";

const Footer = () => {
  return (
    <footer className="bg-black text-yellow-200 font-bold text-center text-xl lg:text-2xl p-3">
      CopyRight &copy; 2022/23. All Rights Reserved.
    </footer>
  );
};

export default Footer;
